import {
  ECategoryType,
  ESpecialOfferType,
  IApiEligibleCategories,
} from 'affiny-core/modules/api/models/payment/eligible-categories.types';
import { IApiEligibleProducts } from 'affiny-core/modules/api/models/payment/eligible-products.types';
import {
  IApiPaymentHistory,
  IPaymentUrl,
  IPaymentUrlSpecialOffer,
  IPaymentWebViewParams,
} from 'affiny-core/modules/api/repositories/payment/payment.types';
import {
  IBuyedProduct,
  IIosTransaction,
} from 'affiny-core/modules/payment/types';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

interface IApiPaymentResponse<Data> {
  data: Data;
}

export const PaymentResource = {
  getEligibleCategories: () =>
    AffinyEndpoint.EligibleCategories.url('')
      .get()
      .json<IApiPaymentResponse<IApiEligibleCategories>>()
      .then(({ data }) => data),

  getEligibleProducts: (category: string) =>
    AffinyEndpoint.EligibleCategories.url(`/${category}/products`)
      .get()
      .json<IApiPaymentResponse<IApiEligibleProducts>>()
      .then(({ data }) => data),

  getWebviewUrl: ({
    actionCode,
    returnUrlOk,
    returnUrlKo,
  }: IPaymentWebViewParams) =>
    AffinyEndpoint.Payment.url('/url')
      .query({
        productType: ECategoryType.PASS,
        returnUrlOk,
        returnUrlKo,
        eventOrigin: actionCode,
      })
      .get()
      .json<IApiPaymentResponse<IPaymentUrl>>()
      .then(({ data }) => data),

  getWebviewUrlWithSpecialOffer: (
    specialOfferType: ESpecialOfferType,
    { actionCode, returnUrlOk, returnUrlKo }: IPaymentWebViewParams
  ) =>
    AffinyEndpoint.Payment.url(`/url/special_offer/${specialOfferType}`)
      .query({
        productType: ECategoryType.PASS,
        returnUrlOk,
        returnUrlKo,
        eventOrigin: actionCode,
      })
      .get()
      .json<IApiPaymentResponse<IPaymentUrlSpecialOffer>>()
      .then(({ data }) => data),

  postTransactionReceipt: (
    product: IBuyedProduct,
    transaction: IIosTransaction
  ) =>
    AffinyEndpoint.Receipt.url('/receipts')
      .post({
        data: {
          type: 'payment_receipt',
          attributes: { product, transaction },
        },
      })
      .res<IApiPaymentResponse<IApiEligibleProducts>>()
      .then(({ data }) => data),

  getHistory: () =>
    AffinyEndpoint.Payment.url('/history')
      .get()
      .json<IApiPaymentResponse<IApiPaymentHistory>>()
      .then(({ data }) => data),
};
